<nz-card>
  <table class="info-table">
    <tbody>
    <tr>
      <td>Tên tài khoản:</td>
      <td class="text-dark font-weight-semibold">{{ user?.userName}}</td>
    </tr>
    <tr>
      <td>Loại tài khoản:</td>
      <td>
        <nz-tag
          nzColor="{{userRoleTypes|where:['value', user?.userRole] | pluck: 'color'}}">{{ userRoleTypes|where:['value', user?.userRole] | pluck: 'name' }}</nz-tag>
      </td>
    </tr>
    <tr>
      <td>Trạng thái:</td>
      <td>
        <nz-badge [nzStatus]="userStatus|where:['value', user?.status] | pluck: 'badge'"
                  [nzText]="userStatus|where:['value', user?.status]|pluck: 'name'"></nz-badge>
      </td>
    </tr>
    <tr>
      <td>Lần đăng nhập cuối:</td>
      <td>{{user?.lastLogin|dateFormat: SysDateFormat.DATE_TIME}}</td>
    </tr>
    </tbody>
  </table>
</nz-card>

<nz-card nzTitle="Thông tin">
  <form nz-form [formGroup]="infoForm" nzLayout="vertical">

    <extend-form nz-row [nzGutter]="[20,20]">
      <extend-form-item labelText="Tên người dùng" nz-col nzMd="6" [errorDefs]="VALIDATORS.name"
                        [errors]="infoF.name.errors" [showError]="isInfoSubmitted" isRequired>
        <input type="text" nz-input formControlName="name" placeholder="e.g. Trần Văn A" maxlength="30">
      </extend-form-item>

      <extend-form-item labelText="Email" nz-col nzMd="6" [errorDefs]="VALIDATORS.email"
                        [errors]="infoF.email.errors" [showError]="isInfoSubmitted">
        <app-input-group-icon prefixIcon="at" prefixIconType="TABLER_ICON">
          <input type="email" nz-input formControlName="email" placeholder="e.g. abc@gmail.com" maxlength="20">
        </app-input-group-icon>
      </extend-form-item>

      <extend-form-item labelText="Số điện thoại" nz-col nzMd="6" [errorDefs]="VALIDATORS.phoneNumber"
                        [errors]="infoF.phoneNumber.errors" [showError]="isInfoSubmitted">
        <app-input-group-icon prefixIcon="phone" prefixIconType="TABLER_ICON">
          <input nz-input formControlName="phoneNumber" placeholder="e.g. 0123456789" maxlength="11">
        </app-input-group-icon>
      </extend-form-item>
      <extend-form-item nz-col nzMd="6">
        <button nz-col nzMd="6" nz-button nzType="primary" class="w-50" (click)="updateInfo()">Cập nhật</button>
      </extend-form-item>
    </extend-form>
  </form>
</nz-card>

<nz-card nzTitle="Đổi mật khẩu">
  <form nz-form [formGroup]="passForm" nzLayout="vertical">

    <extend-form nz-row [nzGutter]="[20,20]">
      <extend-form-item labelText="Mật khẩu cũ" nz-col nzMd="6" [errorDefs]="VALIDATORS.oldPassword"
                        [errors]="passF.oldPassword.errors" [showError]="isPassSubmitted" isRequired>
        <app-input-group-icon prefixIcon="key" prefixIconType="TABLER_ICON"
                              [suffixIcon]="showPassword ? 'eye' : 'eye-off'"
                              suffixIconType="TABLER_ICON"
                              (suffixClickEvent)="showPassword = !showPassword">
          <input [type]="showPassword ? 'text' : 'password'" nz-input formControlName="oldPassword" placeholder="e.g. ******" maxlength="20">
        </app-input-group-icon>
      </extend-form-item>

      <extend-form-item labelText="Mật khẩu mới" nz-col nzMd="6" [errorDefs]="VALIDATORS.newPassword"
                        [errors]="passF.newPassword.errors" [showError]="isPassSubmitted" isRequired>
        <app-input-group-icon prefixIcon="key" prefixIconType="TABLER_ICON"
                              [suffixIcon]="showPassword ? 'eye' : 'eye-off'"
                              suffixIconType="TABLER_ICON"
                              (suffixClickEvent)="showPassword = !showPassword">
          <input [type]="showPassword ? 'text' : 'password'" nz-input formControlName="newPassword" placeholder="e.g. ******" maxlength="20">
        </app-input-group-icon>
      </extend-form-item>

      <extend-form-item labelText="Nhập lại mật khẩu" nz-col nzMd="6" [errorDefs]="VALIDATORS.confirmPassword"
                        [errors]="passF.confirmPassword.errors" [showError]="isPassSubmitted" isRequired>
        <app-input-group-icon prefixIcon="key" prefixIconType="TABLER_ICON"
                              [suffixIcon]="showPassword ? 'eye' : 'eye-off'"
                              suffixIconType="TABLER_ICON"
                              (suffixClickEvent)="showPassword = !showPassword">
          <input [type]="showPassword ? 'text' : 'password'" nz-input formControlName="confirmPassword" placeholder="e.g. ******" maxlength="20">
        </app-input-group-icon>
      </extend-form-item>
      <extend-form-item nz-col nzMd="6">
        <button nz-col nzMd="6" nz-button nzType="primary" class="w-50" (click)="changePassword()">Cập nhật</button>
      </extend-form-item>
    </extend-form>
  </form>
</nz-card>
